export default function PricingDisclosure({ className = "", testid = "pricing-disclosure" }) {
  return (
    <div
      data-testid={testid}
      className={`border border-white/10 bg-[#0B0B0C]/60 px-5 py-4 backdrop-blur-md ${className}`}
    >
      <div className="text-[10px] uppercase tracking-[0.35em] text-[#8E9AA6] mb-2">
        Pricing Notes
      </div>
      <p className="italic text-xs md:text-[13px] leading-relaxed text-[#8E9AA6] font-light">
        Round-Trip Tolls and Parking charges are additional. Base calculations are subject to a
        20% gratuity, fuel surcharges, and a 5% service fee of the subtotal. Massachusetts state
        tax and other local regulatory fees apply. Garage time/distance charges will be added for
        pick-ups and/or drop-offs outside of the greater Boston area.
      </p>
    </div>
  );
}
